<template>
  <div class="page-course">
    <div class="course-cover">
      <img :src="course.cover || coverDefault" alt="">
      <img src="./images/header-mask.png" alt="" class="mask">
    </div>
    <div class="course-contents">
      <div class="course-msgs">
        <div class="course-name">{{course.name}}</div>
        <div class="course-desc">{{course.introduction}}</div>
      </div>
      <div class="course-items">
        <div v-for="(t, i) in course.items"
             :class="`single-item ${singleConfig[t.type].key}`"
             :key="i">
          <div :class="['single-normal', singleConfig[t.type].key, {downloadButton: singleConfig[t.type].key === 'wk' && !inApp}]" @click="serviceGo('course', t)">
            <div :class="`normal-bg ${singleConfig[t.type].key}`"></div>
            <div :class="`tag ${t.tagClass}`" v-if="singleTag(t)">{{singleTag(t)}}</div>
            <div :class="`title ${singleConfig[t.type].key}`">{{t.name}}</div>
            <div class="desc">{{t.introduction}}</div>
            <div class="lock" v-if="!t.onService"></div>
            <div class="wk-down" v-if="singleConfig[t.type].key === 'wk' && !inApp" @click="wkGoApp">去股拍APP观看 ></div>
          </div>
          <div class="live-content" v-if="singleConfig[t.type].key === 'live' && (t.onLive || t.hasNextLive || (t.tapeHistories && t.tapeHistories.length))">
            <div class="live-see-wrap" v-if="t.onLive || t.hasNextLive">
              <button class="btn-see in" v-if="t.onLive" @click="serviceGo('course', t)">立即观看</button>
              <button v-else :class="['btn-see out', {downloadButton: !inApp}]" @click="addRemind(t)">{{inApp ? (t.reminded ? '已添加日历提醒' : '添加提醒') : '去股拍APP，添加提醒不错过'}}</button>
            </div>
            <div v-if="t.hasTape" class="live-tapes">
              <div :class="['tape-item one-line', {downloadButton: !inApp}]" v-for="tape in t.tapeHistories.slice(0, 2)" :key="tape.id" @click="serviceGo('tape', t, tape)">
                {{getFormateDate(tape.createdAt)}} {{tape.title}}
              </div>
            </div>
            <div v-if="t.hasTape" :class="['btn-live-down', {downloadButton: !inApp}]" @click="goTapeList(t)">{{inApp ? '更多回放 >' : '查看更多精彩回放，请下载股拍APP >'}}</div>
          </div>
        </div>
      </div>
    </div>

    <componentLayer v-model="needactivate">
      <div class="activate-content">
        <div class="layer-cover">
          <img :src="course.cover || coverDefault" alt="">
        </div>
        <div class="desc-wrap">
          <p>亲爱的用户：</p>
          <p>您之前购买的课程《{{course.name}}》尚未激活！</p>
          <p>点击下方激活课程按钮，立刻享受服务</p>
        </div>
        <div class="btn-box">
          <!--          <button @click="activate(id, actSucc)">{{inApp ? '激活课程' : '下载股拍APP，激活课程'}}</button>-->
          <button @click="activate({courseId: id}, actSucc)">激活课程</button>
        </div>
      </div>
    </componentLayer>

    <LayerActivateResult ref="layer" v-model="layerStatus" type="succ" :bText="btnText"></LayerActivateResult>
  </div>
</template>

<script>
import storeMixin from '../mixins/store'
import {singleConfig, coverDefault, AUTH_DESC} from './config'
import {dateFormat, javaTimeToBj} from '@spero/spero-utils/src/helpers/date'
import {ORIGIN_LINK} from '@spero/spero-utils/src/constants/origin-link'

import {compareVersion} from '@spero/spero-utils/src/helpers/utils'
import storage from '@spero/spero-utils/src/helpers/storage'

import LayerActivateResult from './components/layer-activate-result'
import componentLayer from '../components/component-layer'
import activateMixin from './activate-mixin'
import csMixins from './cs-mixins'

let ENV = process.env.VUE_APP_ENV || 'test'
let version = /YTX\/([\d.]+)/i.exec(navigator.userAgent) && RegExp.$1 || '0.0.0'

const SENSOR_BASE = {
  title: '财商课程'
}

export default {
  name: 'course',
  props: ['id'],
  mixins: [storeMixin, activateMixin, LayerActivateResult, csMixins],
  components: {
    componentLayer,
    LayerActivateResult
  },
  data () {
    return {
      singleConfig,
      coverDefault,
      course: {
      },
      tagClass: '',
      needactivate: false,
      layerStatus: false,
      cutSecond: 3,
      cutTimer: null
    }
  },
  computed: {
    btnText () {
      return `${this.cutSecond ? this.cutSecond + '秒后' : ''}自动下载/打开股拍`
    }
  },
  watch: {
    loginCount: {
      immediate: true,
      handler: function (v) {
        if (v > 0) {
          if (this.isWechat && !this.USERINFO.isTourist) {
            this.checkCenterUserInfo()
          }
          this.getCourseDetail()
          const {activate} = this.$route.query
          if (activate && !this.inApp) {
            this.layerStatus = true
            this.startCut()
          }
        }
      }
    },
    layerStatus (v) {
      if (!v) {
        clearInterval(this.cutTimer)
      }
    }
  },
  methods: {
    startCut () {
      clearInterval(this.cutTimer)
      this.cutSecond = 3
      this.cutTimer = setInterval(() => {
        this.cutSecond--
        if (this.cutSecond <= 0) {
          clearInterval(this.cutTimer)
          document.querySelector('.layer-content .downloadButton').click()
        }
      }, 1000)
    },
    toLogin () {
      this.SET_PHONE_LOGIN({type: 'login'})
    },
    singleTag (single) {
      const {type} = single
      let n = ''
      this.tagClass = this.singleConfig[single.type].key
      switch (singleConfig[type].key) {
        case 'live': {
          const {onLive, hasNextLive, nextLiveTime} = single
          n = onLive ? '热播中' : (hasNextLive ? ('下一场 ' + dateFormat(javaTimeToBj(nextLiveTime), 'mm-dd HH:MM')) : '')
          if (!onLive && hasNextLive) {
            !single.tagClass && Object.assign(single, {
              tagClass: 'nextLive'
            })
          }
        }
          break
        case 'album':
          n = `共${single.albumCourseNum}节`
          break
        case 'article':
          n = single.articleUpdate ? '有更新' : ''
          break
        case 'wk':
          n = ''
          break
      }
      !single.tagClass && Object.assign(single, {
        tagClass: this.singleConfig[single.type].key
      })
      return n
    },
    noAuth (type) {
      this.$layer2({
        type: 'confirm',
        content: AUTH_DESC[type],
        btnCancel: '切换登录',
        onCancel: () => {
          this.$layer2({content: ''})
          this.toLogin()
        },
        btnSure: '联系班主任',
        onOk: () => {
          this.$layer2({content: ''})
          location.href = 'weixin://dl/'
        }
      })
    },
    serviceGo (type, service, tape) {
      const saObj = {
        eventname: type === 'course' ? '点击服务卡片' : '点击回放',
        goodsname: service.name,
        goodsid: service.id,
        islock: !service.onService ? '是' : '否'
      }
      if (type === 'tape') {
        Object.assign(saObj, {
          videoid: tape.id,
          videotitle: tape.title
        })
      }
      this.$sa.click({
        ...saObj,
        ...SENSOR_BASE
      })
      if (!this.inApp && (type === 'tape' || service.type === 4)) {
        return
      }
      if (this.USERINFO.isTourist) {
        this.toLogin()
        return
      }
      if (!service.onService) {
        this.noAuth('service')
        return
      }
      switch (type) {
        case 'course':
          this.singleGo(service)
          break
        case 'tape':
          this.goTapeItem(service, tape)
          break
      }
    },
    singleGo (single) {
      const {type, id, relation} = single
      const {baseUrl} = window.speroBridge
      switch (singleConfig[type].key) {
        case 'live': {
          // if (single.onLive) {
          const url = ORIGIN_LINK.h5hd[ENV] + 'live/#/' + single.roomId
          const jumpUrl = this.inApp ? window.speroBridge.baseUrl + 'web?hiddenNavigation=true&url=' + encodeURIComponent(url) : url
          this.urlJump(jumpUrl)
          // }
        }
          break
        case 'album': {
          let jumpUrl = ''
          if (type !== 5 && this.inApp) {
            jumpUrl = baseUrl + 'albumDetail?index=list&id=' + relation.id
          } else {
            let hash = type === 5 ? `/net-pay/album/${relation.id}` : `/album/${relation.id}`
            const url = ORIGIN_LINK.spero[ENV] + `app-h5/?token=${this.USER_TOKEN}#` + hash
            jumpUrl = this.inApp ? baseUrl + 'web?url=' + encodeURIComponent(url) : url
          }
          this.urlJump(jumpUrl)
        }
          break
        case 'article':
          this.$router.push({name: 'article-list', params: {id}})
          break
        case 'wk': {
          if (this.inApp) {
            let url = single.weikeUrl
            if (!/^spero/.test(url)) {
              url = baseUrl + 'web?url=' + encodeURIComponent(url)
            }
            this.urlJump(url)
          }
        }
          break
      }
    },
    goTapeList ({id}) {
      this.$sa.click({
        eventname: '点击查看更多',
        ...SENSOR_BASE
      })
      if (!this.inApp) {
        return
      }
      this.$router.push({name: 'play-list', params: {id}})
    },
    goTapeItem (service, tape) {
      const url = ORIGIN_LINK.h5hd[ENV] + `live/?tapeId=${tape.id}#/${service.roomId}`
      const jumpUrl = this.inApp ? window.speroBridge.baseUrl + 'web?url=' + encodeURIComponent(url) : url
      this.urlJump(jumpUrl)
    },
    addRemind (single) {
      this.$sa.click({
        eventname: '点击添加提醒',
        ...SENSOR_BASE
      })
      if (!this.inApp || single.reminded) {
        return
      }
      if (compareVersion(version, '8.1.0') < 0) {
        this.$layer2({
          type: 'confirm',
          content: '请升级APP到最新版后<br />再尝试此功能',
          onOk: () => {
            this.$layer2({content: ''})
          }
        })
        return
      }
      single.user = single.user || {nickname: '测试老师'}
      const {name: courseName} = this.course
      const {nextLiveTime: nextStart, nextEndTime: nextEnd, user: {nickname}, name: goodsName, roomId} = single
      const {event: {action}} = window.speroBridge
      window.YTXBridge && window.YTXBridge.fireEvent(action, {
        actionType: '42',
        data: {
          calendarData: {
            title: `${nickname} ${goodsName}`,
            notes: `${courseName}的${goodsName}的直播即将开始，请准备~`,
            startDate: new Date(javaTimeToBj(nextStart)).getTime(),
            endDate: new Date(javaTimeToBj(nextEnd)).getTime(),
            url: window.speroBridge.baseUrl + 'web?url=' + encodeURIComponent(location.href),
            isAdded: true,
            alarms: [5, 0]
          }
        }
      }, (cb) => {
        cb = JSON.parse(cb)
        if (cb.result) {
          storage.set(`${roomId}-${nextStart}`, 1)
          this.$set(single, 'reminded', 1)
          this.$toast('添加成功')
        }
      })
    },
    wkGoApp () {
      this.$sa.click({
        eventname: '点击去股拍APP观看',
        ...SENSOR_BASE
      })
    },
    async getCourseDetail () {
      try {
        const {data: {code, data, message}} = await this.$rootApi.api(['courseDetail'], {
          data: {
            id: this.id
          }
        })
        if (code === 0) {
          // console.log('data', data)
          let noAuthCount = 0
          const live = [], album = [], article = [], wk = []
          const {serviceContentDtos: course, needActivate, activation} = data
          course.forEach(t => {
            !t.onService && noAuthCount++
            switch (t.type) {
              case 2:
                live.push(t)
                break
              case 3:
              case 5:
                album.push(t)
                break
              case 1:
                article.push(t)
                break
              case 4:
                wk.push(t)
                break
            }
          })
          if (this.USERINFO.isTourist) {
            this.toLogin()
          } else if (noAuthCount === course.length) {
            // 没有任何一个服务有权限可观看
            switch (needActivate) {
              case 0:
                // 无需激活课程，判断为无此课程权限
                this.noAuth('course')
                break
              case 1:
                // 用户自主激活课程，依字段判断为【已购买未激活】和【未购买无权限】
                if (!activation && typeof activation === 'boolean') {
                  this.needactivate = true
                } else {
                  this.noAuth('course')
                }
                break
              case 2:
                // 班级激活课程,依字段判断为【已购买未激活】和【未购买无权限】
                if (!activation && typeof activation === 'boolean') {
                  this.noAuth('class')
                } else {
                  this.noAuth('course')
                }
                break
            }
          }
          live.forEach(t => {
            const {hasNextLive, roomId, nextLiveTime} = t
            if (hasNextLive && storage.get(`${roomId}-${nextLiveTime}`)) {
              t.reminded = 1
            }
          })
          Object.assign(this, {
            course: Object.assign(data, {
              items: [].concat(live, album, article, wk)
            })
          })
          Object.assign(SENSOR_BASE, {
            courseid: this.id,
            coursename: data.name,
            productid: this.inApp ? 'gpapp' : 'h5gp'
          })
          this.$sa.pageview(SENSOR_BASE)
        } else {
          throw message
        }
      } catch (e) {
        // e && this.$toast(e.message || e)
      }
    },
    openInstallFn () {
      const entersource = 'h5_1aa00_a143_0'
      this.openInstallInit(this.$route, {
        entersource,
        openinstallLink: `${window.speroBridge.baseUrl}web?url=${encodeURIComponent(location.href)}`
      }, false)
    },
    actSucc () {
      this.$toast('课程激活成功')
      this.getCourseDetail()
    }
  },
  created () {
    this.openInstallFn()
  }
}
</script>

<style lang="stylus" scoped>
@import "./stylus/course.styl"
</style>
